module.exports = __webpack_public_path__ + "static/media/concert1.f74e43c3.jpg";